import { useMutation } from "@shared/lib/hooks"; // Ensure this is the correct import
import { ToastService } from "@shared/lib/services";
import { SocialMedia } from "@shared/lib/types/influencer";
import { DiscoveryService } from "../services/discovery.service";
import { BackednResponse } from "@shared/lib/types";
import { useGetInfluencerStore } from "../store/useGetInfluencerStore";
import { DownloadService } from "@entities/downloads/lib/services/Download.service";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";

export function useDownloadBucketInfluencers() {
  const { platform, username, backendFIlters } = useGetInfluencerStore();
  const {
    mutate: downloadInfluencers,
    isLoading: isDownloading,
    isSuccess: isDownloaded,
  } = useMutation<{ bucketId: string }>({
    mutationFn: async ({ bucketId }) => {
      return await DownloadService.downloadInfluencers(
        platform,
        username,
        backendFIlters,
        bucketId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },

    onSuccess: (c, _) => {
      ToastService.success("Added to Download Queue");
      c.invalidateQueries({ queryKey: [DOWNLOADS_LIST_QUERY_KEY] });
    },
    options: {},
  });

  return {
    downloadInfluencers,
    isDownloading,
    isDownloaded,
  };
}
